const DEFAULT_EMPTY_TEXT = "No hay registros disponibles";

// Estados visuales de la tabla: vacía, primera carga (esqueleto) y sin
// columnas. `noDataText={false}` deshabilita el mensaje de vacío.
export default function getDataTableStatus({ columns, data, loading, noDataText }) {
  const hasRows = !!data?.length;
  const hideEmptyState = noDataText === false;
  const isEmpty = !loading && !hasRows;

  return {
    hasRows,
    hasColumns: columns.some(Boolean),
    hideEmptyState,
    isEmpty,
    isLoadingWithoutRows: !!loading && !hasRows,
    emptyText:
      isEmpty && !hideEmptyState ? noDataText || DEFAULT_EMPTY_TEXT : null,
    noDataText: hideEmptyState ? "" : noDataText || DEFAULT_EMPTY_TEXT,
  };
}
